import { Col, Checkbox, Spin } from "antd";
import {
  TableColumns,
  TableProperties,
} from "../../../../shared/components/ui/Table/types";
import { ProgramScheduleType } from "../../../../types/dto/program";
import React from "react";
import {
  programPaymentScheduleAcademy,
  programPaymentScheduleStudentAcademy,
} from "../../../../shared/services";
import { useParams } from "react-router-dom";
import moment from "moment";
import useProgramStudent from "../../../academyProgramDetail/hooks/students/useProgramStudent";
import { formatNumberPrice } from "../../../../shared/utils/Helper";
import useCreatePaymentScheduleStudent from "../../../AcademyStudentSchedulePayment/hooks/useCreatePaymentScheduleStudent";
import Table from "../../../../shared/components/ui/Table/prueba";

export const TablePaymentScheduleStudent = () => {
  const { user_id, program_id } = useParams();
  const [dataStudentSchedules, setDataStudentSchedules] = React.useState<any[]>(
    []
  );
  const [tableInstance, setTableInstance] = React.useState<TableProperties>();

  const { programStudentsByUserIdAndProgramId } = useProgramStudent({
    program_id: +program_id!,
    user_id: +user_id!,
  });

  const { updateOrCreateScheduleStudent, loadingUpdateOrCreate } =
    useCreatePaymentScheduleStudent();

  const fetchStudentScheduleData = React.useCallback(async () => {
    const filterData = programStudentsByUserIdAndProgramId.map((it) => it.id);
    const { data } = await programPaymentScheduleStudentAcademy.find({
      query: {
        $limit: 1000,
        program_student_id: { $in: filterData },
      },
    });
    setDataStudentSchedules(data || []);
  }, [programStudentsByUserIdAndProgramId]);

  const handleAssignSelected = React.useCallback(
    async (item: any, checked: boolean) => {
      const result = await updateOrCreateScheduleStudent({
        program_student_id: programStudentsByUserIdAndProgramId[0]?.id,
        payment_schedule_id: item.id,
      });

      if (result && result.id) {
        setDataStudentSchedules((prev) => {
          const existingIndex = prev.findIndex(
            (schedule) =>
              schedule.payment_schedule_id === item.id &&
              schedule.program_student_id ===
                programStudentsByUserIdAndProgramId[0]?.id
          );

          if (result.status === "active") {
            if (existingIndex >= 0) {
              const updated = [...prev];
              updated[existingIndex] = {
                ...updated[existingIndex],
                status: "active",
              };
              return updated;
            } else {
              return [
                ...prev,
                {
                  id: result.id,
                  payment_schedule_id: item.id,
                  program_student_id:
                    programStudentsByUserIdAndProgramId[0]?.id,
                  status: "active",
                },
              ];
            }
          } else {
            return prev.filter(
              (schedule) =>
                !(
                  schedule.payment_schedule_id === item.id &&
                  schedule.program_student_id ===
                    programStudentsByUserIdAndProgramId[0]?.id &&
                  schedule.status === "active"
                )
            );
          }
        });
      }

      await fetchStudentScheduleData();
    },
    [
      updateOrCreateScheduleStudent,
      programStudentsByUserIdAndProgramId,
      fetchStudentScheduleData,
    ]
  );

  React.useEffect(() => {
    if (programStudentsByUserIdAndProgramId.length > 0) {
      fetchStudentScheduleData();
    }
  }, [program_id, fetchStudentScheduleData]);

  const fetchQueryProps = React.useMemo(
    () => ({
      program_id: +program_id!,
      $sort: { id: -1 },
    }),
    [program_id]
  );

  const columns: TableColumns<ProgramScheduleType> = React.useMemo(
    () => [
      {
        title: "ID",
        dataIndex: "id",
        width: 1,
        key: "id",
      },
      {
        title: "Mes de cobro",
        dataIndex: "month",
        key: "month",
        width: 3,
        render: (_, item: ProgramScheduleType) => {
          return (
            <Col
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
              }}
            >
              <span className="capitalize">
                {moment(item.month).format("MMM / YYYY")}
              </span>
            </Col>
          );
        },
        sorter: true,
        sortDirections: ["ascend", "descend"],
        defaultSortOrder: "ascend",
      },
      {
        title: "Fecha límite de pago",
        dataIndex: "day_of_month_payment_limit",
        key: "day_of_month_payment_limit",
        width: 3,
        render: (_, item: ProgramScheduleType) => (
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <span className="capitalize">
              {moment(item.day_of_month_payment_limit).format("YYYY/MM/DD")}
            </span>
          </Col>
        ),
      },
      {
        title: "Valor extraordinario",
        dataIndex: "price",
        key: "price",
        width: 3,
        render: (_, item: ProgramScheduleType) => (
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <span className="capitalize">{formatNumberPrice(+item.price)}</span>
          </Col>
        ),
      },
      {
        title: "Valor pronto pago",
        dataIndex: "price_with_prompt_payment_discount",
        key: "price_with_prompt_payment_discount",
        width: 3,
        render: (_, item: ProgramScheduleType) => (
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <span className="capitalize">
              {formatNumberPrice(+item.price_with_prompt_payment_discount)}
            </span>
          </Col>
        ),
      },
      {
        title: "Asignar",
        key: "operation",
        width: 1,
        fixed: "right",
        render: (_, item, i) => {
          return (
            <Col
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
                gap: 15,
              }}
            >
              <Checkbox
                checked={
                  !!dataStudentSchedules.find(
                    (schedule) =>
                      schedule.payment_schedule_id === item.id &&
                      schedule.status === "active"
                  )
                }
                onChange={(e) => handleAssignSelected(item, e.target.checked)}
              />
            </Col>
          );
        },
      },
    ],
    [dataStudentSchedules, handleAssignSelected]
  );

  return (
    <>
      {loadingUpdateOrCreate && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <Spin spinning={true} />
        </div>
      )}
      <Table<ProgramScheduleType>
        columns={columns}
        fetchQueryProps={fetchQueryProps}
        service={programPaymentScheduleAcademy}
        onLoad={(instance) => setTableInstance(instance)}
      />
    </>
  );
};
